<template>
  <div class="content-view">
    <div class="left-content">
       <dataAnalysisSideBar></dataAnalysisSideBar>
    </div>
    <div class="right-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script type="text/javascript">
import dataAnalysisSideBar from './dataAnalysisSideBar.vue'
export default {
  name: 'dataAnalysisContent',
  components: {
    dataAnalysisSideBar
  }
}
</script>
